import React, { useState, useEffect } from 'react';
import { FaCoffee } from 'react-icons/fa';
import { resolveMediaUrl } from '../utils/media';

interface CafeAvatarProps {
  imageUrl?: string | null;
  name: string;
  className?: string;
}

/** Small cafe thumbnail — loads immediately (no lazy observer) for list rows. */
export default function CafeAvatar({ imageUrl, name, className = 'w-12 h-12' }: CafeAvatarProps) {
  const [failed, setFailed] = useState(false);
  const resolved = resolveMediaUrl(imageUrl);

  useEffect(() => {
    setFailed(false);
  }, [imageUrl]);

  const showImage = Boolean(resolved) && !failed;

  return (
    <div
      className={`rounded-lg overflow-hidden bg-amber-100 shrink-0 flex items-center justify-center ${className}`}
    >
      {showImage ? (
        <img
          src={resolved!}
          alt={name}
          className="w-full h-full object-cover"
          loading="eager"
          decoding="async"
          onError={() => setFailed(true)}
        />
      ) : (
        <FaCoffee className="text-xl text-amber-700" aria-hidden />
      )}
    </div>
  );
}
